import styled from "styled-components";

export const Container = styled.button`
    background-color: rgb(0,0,0,0.1);
    color: ${props => props.theme.colors.primaryText};
    border: none;
    border-radius: 3px;
    display: block;
    flex-direction: row;
    height: 25px;
    align-items: center;
    padding: 1px;
    font-size: center;
    cursor: pointer;
    z-index: 4;

    @media (min-width: 576px) {
        background-color: rgb(0,0,0,0);
        color: ${props => props.theme.colors.primaryText};
    }
`;